import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ReelCutting } from '../../../../../core/model';
import { PyStateUtils } from '../../../../../core/state';
import { CartState, ReelCuttingState, StateWithCart } from '../cart-state';
import { getCartState } from './feature.selector';

export const getReelCuttingState: MemoizedSelector<StateWithCart, ReelCuttingState> = createSelector(
  getCartState,
  (state: CartState) => state && state.reelCutting
);

export const getReelCuttingPricesState: MemoizedSelector<
  StateWithCart,
  StateUtils.EntityLoaderState<ReelCutting>
> = createSelector(getReelCuttingState, (state: ReelCuttingState) => state.prices);

export const getReelCuttingPriceStateFactory = (
  key: string
): MemoizedSelector<StateWithCart, StateUtils.LoaderState<ReelCutting>> => {
  return createSelector(
    getReelCuttingPricesState,
    (state) => (state && PyStateUtils.entityLoaderStateSelector(state, key)) || PyStateUtils.initialLoaderState
  );
};

export const getReelCuttingPriceFactory = (key: string): MemoizedSelector<StateWithCart, ReelCutting | undefined> => {
  return createSelector(
    getReelCuttingPriceStateFactory(key),
    (state) => (state && StateUtils.loaderValueSelector(state)) || undefined
  );
};

export const getReelCuttingPriceLoadingFactory = (key: string): MemoizedSelector<StateWithCart, boolean> => {
  return createSelector(getReelCuttingPriceStateFactory(key), (state) => StateUtils.loaderLoadingSelector(state));
};

export const getReelCuttingPriceLoadedFactory = (key: string): MemoizedSelector<StateWithCart, boolean> => {
  return createSelector(getReelCuttingPriceStateFactory(key), (state) => StateUtils.loaderSuccessSelector(state));
};
